import { CloseIcon } from '@chakra-ui/icons'
import { 
  Button,
  Flex,
  Modal,
  ModalBody, 
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text 
} from '@chakra-ui/react'

export const MainModal = ({ children, isOpen, onClose, width="1000px", showFooter=true, title="", onConfirm=() => {}, isDisabled = false }) => {
  return (
    <Modal
      closeOnOverlayClick={true}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent w={width} maxW="80vw" padding="40px">
        <ModalHeader padding="0">
          <Flex justifyContent="space-between" alignItems="center">
            <Text>{title}</Text>
            <CloseIcon onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody
          marginTop="10px"
        >
          {children}
        </ModalBody>
        {showFooter && <ModalFooter>
          <Flex>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button variant="ghost" isDisabled={isDisabled} onClick={onConfirm}>
              Подтвердить
            </Button>
          </Flex>
        </ModalFooter>}
      </ModalContent>
    </Modal>
  );
};
